export default __webpack_public_path__ + "static/media/help.dd93b484.svg";